module.exports = LZString;